<div class="cgp-wrapper">
  <div class="cgp-toolbar">
    <h1 class="cgp-page-title">Customer Groups</h1>
    <button class="cgp-create-btn" (click)="openCreate()">
      <i class="fa-solid fa-plus"></i> New Group
    </button>
  </div>

  @if (loading() && groups().length === 0) {
    <div class="cgp-loading"><i class="fa-solid fa-spinner fa-spin"></i></div>
  } @else if (groups().length === 0) {
    <div class="cgp-empty">
      <i class="fa-solid fa-layer-group cgp-empty-icon"></i>
      <p>No customer groups yet.</p>
      <button class="cgp-create-btn" (click)="openCreate()">Create your first group</button>
    </div>
  } @else {
    <div class="cgp-grid">
      @for (group of groups(); track group.id) {
      <a class="cgp-card" [routerLink]="['/customer-groups', group.id]" (click)="onGroupCardClick($event, group)" (keydown.enter)="openGroup(group)">

        <!-- Top: badge left + content right -->
        <div class="cgp-card-top">
          <!-- Badge column -->
          <div class="cgp-card-badge-panel">
            @if (group.badgeUrl) {
              <img [src]="group.badgeUrl" alt="badge" class="cgp-card-badge" />
            } @else {
              <div class="cgp-card-badge-placeholder" [style.border-color]="group.color + '66'" [style.color]="group.color" [style.background]="group.color + '14'">
                {{ group.name[0].toUpperCase() }}
              </div>
            }
          </div>

          <!-- Content column -->
          <div class="cgp-card-content">
            <!-- Row 1: name + status + actions -->
            <div class="cgp-card-row1">
              <div class="cgp-color-dot" [style.background]="group.color"></div>
              <h3 class="cgp-card-name">{{ group.name }}</h3>
              <span class="cgp-status-chip" [class.inactive]="group.status === 'INACTIVE'">
                {{ group.status === 'ACTIVE' ? 'Active' : 'Inactive' }}
              </span>
              <div class="cgp-card-actions">
                <button class="cgp-action-btn cgp-edit-btn" (click)="openEdit(group, $event)" title="Edit">
                  <i class="fa-solid fa-pen"></i>
                </button>
                <button class="cgp-action-btn cgp-delete-btn" (click)="openDelete(group, $event)" title="Delete">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>

            <!-- Row 2: description -->
            <div class="cgp-card-row2">
              @if (group.description) {
                <p class="cgp-card-desc">{{ group.description }}</p>
              } @else {
                <p class="cgp-card-no-desc">No description</p>
              }
            </div>
          </div>
        </div>

        <!-- Footer: full width -->
        <div class="cgp-card-footer">
          <span class="cgp-card-members">
            <i class="fa-solid fa-users"></i> {{ group.memberCount }} members
          </span>
          <span class="cgp-card-discount">
            @if (group.maxDiscountPercentage !== null && group.maxDiscountPercentage !== undefined) {
              <i class="fa-solid fa-tag"></i> Up to {{ group.maxDiscountPercentage }}%
            } @else {
              No discount
            }
          </span>
        </div>

      </a>
      }
    </div>
  }
</div>

<app-add-group-form
  [(visibility)]="addDialogVisible"
  [editGroup]="editingGroup"
  (saved)="onGroupSaved()"
  (created)="onGroupSaved()" />

<!-- Delete confirm dialog -->
@if (deletingGroup) {
<p-dialog
  header="Delete Group"
  [(visible)]="confirmDeleteVisible"
  [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  styleClass="cgp-confirm-dialog"
  (onHide)="deletingGroup = null">
  <p class="cgp-confirm-text">
    Are you sure you want to delete <strong>{{ deletingGroup.name }}</strong>? This cannot be undone.
  </p>
  <ng-template pTemplate="footer">
    <button class="cgp-cancel-btn" (click)="confirmDeleteVisible = false; deletingGroup = null">Cancel</button>
    <button class="cgp-delete-confirm-btn" (click)="confirmDeleteGroup()" [disabled]="deleteLoading()">
      @if (deleteLoading()) { <i class="fa-solid fa-spinner fa-spin"></i> Deleting… }
      @else { <i class="fa-solid fa-trash"></i> Delete }
    </button>
  </ng-template>
</p-dialog>
}
